import React from 'react';
import emailjs from '@emailjs/browser';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
const Contact = () => {
    const sendMail = e => {
        e.preventDefault();

        emailjs.sendForm('service_3hrlgxb', 'template_i1tqlxo', e.target, 'JArlF6Z-LKHC0GtCg')
            .then((result) => {
                if (result.text === 'OK') {
                    toast.success('Message send succesfully')
                    e.target.reset()
                }
            }, (error) => {
                console.log(error.text);
            });

    }
    return (
        <div data-aos="fade-up"
            data-aos-duration="3000" className='w-4/5 mx-auto my-10' id='contact'>
            <h2 className='text-4xl font-bold'>Contact me</h2>
            <div className="form-control w-full max-w-md">
                <form onSubmit={sendMail}>
                    <label className="label">
                        <span className="label-text">Your Name</span>
                    </label>
                    <input type="text" placeholder="Name" className="input input-bordered w-full max-w-md" name='name' />
                    <label className="label">
                        <span className="label-text">Your Email</span>
                    </label>
                    <input type="text" placeholder="Name" className="input input-bordered w-full max-w-md" name='email' />
                    <label className="label">
                        <span className="label-text">Subject</span>
                    </label>
                    <input type="text" placeholder="Subject" className="input input-bordered w-full max-w-md" name='subject' />

                    <label className="label">
                        <span className="label-text">Your Message</span>
                    </label>
                    <textarea className="textarea textarea-bordered h-24 w-full" placeholder="Your message" name='message'></textarea>
                    <input className='btn my-2' type="submit" value="Send" />
                </form>
            </div>
            <ToastContainer
                position="top-center"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
        </div>
    );
};

export default Contact;